import { getAccessToken } from './cookieUtils'

/**
 * Wraps the native fetch with an Authorization header populated from the
 * current access token cookie. Use this for SWR (or plain fetch) calls to
 * external services (e.g. the user-service) that sit outside the same-origin
 * fetch interceptor's scope.
 *
 * If no token is present the request is sent without an Authorization header
 * so the upstream service can return a proper 401.
 */
export async function authenticatedFetch(
  url: string,
  init?: RequestInit,
): Promise<Response> {
  const token = getAccessToken()

  const headers = new Headers(init?.headers)
  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  return fetch(url, {
    ...init,
    headers,
  })
}
